import { batch } from "react-redux";
import { BuildClientPayload } from "@/components/common/types/BuildClientPayload";
import { fetchAuthTokenViaRefreshApi } from "@/redux/slice/auth/apis/fetchAuthTokenViaRefresh";
import { updateAuthToken, updateTokenRefresh } from "@/redux/slice/auth/slice";
import { AuthRefreshPayload } from "@/redux/slice/auth/types/AuthRefreshPayload";
import { SignOutActions } from "@/redux/slice/auth/types/SignOutActions";
import authLogout from "@/redux/slice/auth/actions/authLogout";
import firebaseRepo from "@/libs/firebase";

export default async function getFreshTokenBeforeSixtyMinutes(
  getFreshTokenPayload: BuildClientPayload & {
    tokenJustGotRefetched: boolean;
    dispatch: any;
  }
) {
  const { apolloClient, tokenJustGotRefetched, dispatch } = getFreshTokenPayload;

  const handleUnAuthenticated = () => {
    const signOutActions: SignOutActions = {
      dispatchSignOutUpdates() {
        authLogout({ apolloClient, dispatch });
      },
    };

    firebaseRepo.getInstance().signOut(signOutActions);
  };

  const authRefreshPayload: AuthRefreshPayload = {
    grant_type: "refresh_token",
    refresh_token: localStorage.getItem("refreshToken"),
  };

  try {
    const resolvedRequest = await fetchAuthTokenViaRefreshApi(authRefreshPayload);
    if (resolvedRequest?.refresh_token) localStorage.setItem("refreshToken", resolvedRequest.refresh_token);
    batch(() => {
      if (tokenJustGotRefetched) dispatch?.(updateTokenRefresh(true));
      dispatch?.(updateAuthToken(resolvedRequest.id_token));
    });
  } catch (e) {
    console.error("The id token fetch failed", e);
    handleUnAuthenticated();
  }
}
